// deps
import React, { RefObject, useMemo } from "react";
// types
import { TGLogoCTX, PlanDetails } from "@swiggy-private/cart-types";
import { IVariants } from "@super-ui/components/cart-upsell-nudge/types";
// constants
import { CART_UPSELL_TEST_IDS, TITLE_HEIGHT, TITLE_VARIANTS } from "@super-ui/components/cart-upsell-nudge/constants";
import { PLACEHOLDERS } from "@super-ui/constants";
// helpers
import {
    animatedTitleNodeBuilder,
    titleNodeBuilder,
} from "@super-ui/components/swiggy-one-widget-dls-wrapper/helpers/nodeBuilders";
// styles
import { AnimatedTitlesContainer, Title } from "./styles";

interface IProps {
    logoCtx: TGLogoCTX;
    text: string;
    planDetails: PlanDetails;
    variant: keyof IVariants;
    titleRef: RefObject<HTMLDivElement>;
}

function TitleWrapper({ logoCtx, text, planDetails, variant, titleRef }: IProps) {
    const shouldAnimate = useMemo(() => text.includes(PLACEHOLDERS.ANIMATE_IDENTIFIER), [text]);

    const parsedTitle = shouldAnimate
        ? animatedTitleNodeBuilder({
              displayText: text,
              logo: logoCtx?.logo,
              eligiblePlanDetails: planDetails,
              config: TITLE_VARIANTS[variant],
              titleHeight: TITLE_HEIGHT[variant],
          })
        : titleNodeBuilder(text, logoCtx?.logo, planDetails, TITLE_VARIANTS[variant]);

    if (shouldAnimate) {
        return (
            <AnimatedTitlesContainer data-testid={CART_UPSELL_TEST_IDS.ANIMATED_TITLE}>
                {parsedTitle}
            </AnimatedTitlesContainer>
        );
    }

    return <Title ref={titleRef}>{parsedTitle}</Title>;
}

export default React.memo(TitleWrapper);
